<template>
    <div>
        <h3>反馈记录</h3>
        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="id" label="反馈ID"></el-table-column>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
            <el-table-column prop="nickname" label="用户昵称"></el-table-column>
            <el-table-column prop="deviceType" label="客户端类型">
                <template slot-scope="scope">{{map.deviceTypes[scope.row.deviceType]}}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="反馈时间"></el-table-column>
            <el-table-column prop="content" label="反馈内容"></el-table-column>
        </el-table>
        <br/>
        <div>
            <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="i=>pageNum=i" :page-size="limit" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'

const {
    user
} = api

export default {
    name: 'feedbacks',
    data() {
        return {
            map,
            loading: true,
            list: [],
            limit: 20,
            pageNum: 1,
            total: 0,
        }
    },
    components: {},
    computed: {
    },
    watch: {
        pageNum() {
            this.fetch(2)
        },
    },
    methods: {
        async fetch(num) {

            if (num == 1) {
                this.pageNum = 1
            }

            let pageNum = this.pageNum
            let limit = this.limit
            this.loading = true

            let obj = {
                pageNum: pageNum,
                limit: limit,
            }

            let res = await user.feedbacks(obj)

            this.list = res.data.data
            this.loading = false
            this.total = res.data.pageinfo.totalCount
        },
    },
    mounted() {
        this.fetch()
    },
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/feedback/feedbacks.vue